module.exports = __webpack_public_path__ + "img/cowbell.d2260170.svg";